import { Application, APPLICATION_HEADER_NAME, Platform, PLATFORM_HEADER_NAME, Platforms, } from '@lucidlink/dto/validation';
const createPlatformHeader = (platform) => {
    return Platforms.includes(platform)
        ? { [PLATFORM_HEADER_NAME]: platform }
        : undefined;
};
const isValidApplication = (value) => Object.values(Application).includes(value);
const createApplicationHeader = (application) => {
    return isValidApplication(application)
        ? { [APPLICATION_HEADER_NAME]: application }
        : undefined;
};
export const createSdkDefaultHeaders = (application, platform) => {
    const platformHeader = createPlatformHeader(application === Application.Web ? Platform.WEB : platform);
    const applicationHeader = createApplicationHeader(application);
    return {
        ...platformHeader,
        ...applicationHeader,
    };
};
